import React from 'react'
import Hero from '../components/Hero'
import TextSection from '../components/TextSection'

import { textsection_fourcontractor } from '../data/TextsectionData.jsx';
import OfficeLocation from '../components/OfficeLocation.jsx';

const Contractors = () => {

  return (
    <>
     <Hero
      title="Connect with our contractor support team."
      description=""
      buttonText=""
      customClass="contractorBanner"
      imageSrc="/images/hero.png"
      squareColor="Contractorsquare-bg-color"
    />
     <TextSection  data={textsection_fourcontractor} withSpan={false}/>

     <OfficeLocation/>
    </>
   
  )
}

export default Contractors